import { useEffect, useRef, useCallback } from "react";
import { useHeartbeatMutation } from "@/hooks/useMates";
import { MATE_CONFIG } from "@/config/mateConfig";

export function useHeartbeat() {
  const heartbeatMutation = useHeartbeatMutation();
  const lastHeartbeatRef = useRef<number>(0);

  const sendHeartbeat = useCallback(() => {
    const now = Date.now();
    if (now - lastHeartbeatRef.current >= MATE_CONFIG.HEARTBEAT_THROTTLE_MS) {
      lastHeartbeatRef.current = now;
      heartbeatMutation.mutate();
    }
  }, [heartbeatMutation]);

  useEffect(() => {
    // Send heartbeat on initial load
    sendHeartbeat();

    // Send heartbeat when page becomes visible
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        sendHeartbeat();
      }
    };

    // Send heartbeat when window gains focus
    const handleFocus = () => {
      sendHeartbeat();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [sendHeartbeat]);

  return { sendHeartbeat };
}